export default __webpack_public_path__ + "static/media/ginscreen.9c9ac40f.png";